import axios from "axios";

export function getVehicleTypes(filters: any = null) {
  let requestData
  if (typeof filters !== 'undefined') {
    requestData = {
      params: filters
    }
  }
  return axios.get('/vehicle-types', requestData)
}

export function getVehicleType(id: number|string) {
  return axios.get('/vehicle-types/' + id)
}

export function createVehicleType(data: FormData) {
  return axios.post('/vehicle-types', data)
}

export function updateVehicleType(id: number|string, data: FormData) {
  return axios.post('/vehicle-types/' + id, data)
}

export function deleteVehicleType(id: number|string) {
  return axios.delete('/vehicle-types/' + id)
}
